import { JDE_PRICE_STATUS } from '../../lib/api-routes'
import { HttpResponse, instance } from '../../lib/axiosInstance'
import {
  IJdePriceStatusParams,
  IJdePriceStatusResponse,
} from '../../types/jdePriceStatus.interface'

/**
 * Fetches the live JDE base price and status for a community plan from the
 * BFF. The overlay is best-effort, so any error resolves to undefined and the
 * caller falls back to the stored document values.
 */
export const getJdePriceStatus = async (
  params: IJdePriceStatusParams
): Promise<HttpResponse<IJdePriceStatusResponse> | undefined> => {
  try {
    return await instance.get<IJdePriceStatusResponse>(JDE_PRICE_STATUS, {
      params,
    })
  } catch (e) {}
  return undefined
}
